import {
  NgModule
} from '@angular/core';
import {
  OrdersComponent
} from './orders.component';
import {
  ButtonsModule
} from '@progress/kendo-angular-buttons';
import {
  GridModule
} from '@progress/kendo-angular-grid';
import {
  DateInputsModule
} from '@progress/kendo-angular-dateinputs';
import {
  DropDownsModule
} from '@progress/kendo-angular-dropdowns';
import {
  InputsModule
} from '@progress/kendo-angular-inputs';
import {
  SharedCommonModule
} from '../shared/common';
import {
  OrdersService
} from './orders.service';
import {
  LoadingIndicatorModule
} from '../shared/layout/components/loading-indicator/loading-indicator.module';
import {BreadcrumbModule} from '../shared/layout/components/breadcrumb/breadcrumb.module';
import {MatExpansionModule} from '@angular/material/expansion';

@NgModule({
  declarations: [
    OrdersComponent
  ],
  imports: [
    ButtonsModule,
    GridModule,
    DateInputsModule,
    DropDownsModule,
    InputsModule,
    LoadingIndicatorModule,
    MatExpansionModule,
    BreadcrumbModule,
    SharedCommonModule
  ],
  providers: [
    OrdersService
  ]
})
export class OrdersModule {
}
